import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TrendingUpRoundedIcon from "@mui/icons-material/TrendingUpRounded";
import StatCard from "./StatCard";
import { useDataProvider } from "react-admin";
import { useState, useEffect } from "react";
import { useCurrentProject } from "../../contexts/AccountProjectContext";
import { IfCanAccess, useCanAccess } from "@react-admin/ra-rbac";

function Transactions() {
  const { t }: { t: any } = useTranslation();
  const dataProvider = useDataProvider();
  const { codeProject } = useCurrentProject();
  const { accountId } = useCurrentProject();
  const { isLoading, canAccess } = useCanAccess({
    action: 'list',
    resource: 'cryptoOrdersStatistics',
  });

  const [amount, setAmount] = useState(0);

  useEffect(() => {
    if (!accountId || isLoading || !canAccess) return;
    const monthStart = new Date();
    monthStart.setDate(1);
    monthStart.setHours(0, 0, 0, 0);

    const filter: any = {
      accountId,
      statusOrder: "success",
      dateCreated: { ">=": monthStart.toISOString().substring(0, 10) },
    };

    if (codeProject) {
      filter.codeProject = codeProject;
    }

    dataProvider
      .getList("cryptoOrdersStatistics", {
        filter,
        pagination: { page: 1, perPage: 1 },
        sort: { field: "createdAt", order: "DESC" },
      })
      .then(({ data }) => {
        const total = data?.[0]?.totalEuroAmount ?? 0;
        setAmount(total);
      })
      .catch(console.error);
  }, [accountId, codeProject, dataProvider, isLoading, canAccess]);

  
  return (
    <StatCard
      icon={<TrendingUpRoundedIcon />}
      label={t("Volume this month")}
      footer={
        <Link component={RouterLink} to="/cryptoOrders" underline="hover">
          {t("View transactions")} →
        </Link>
      }
    >
      <Typography variant="h2" color="text.primary" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {amount.toLocaleString("fr-FR", { style: "currency", currency: "EUR" })}
      </Typography>
    </StatCard>
  );
}

export default Transactions;
